import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { notification } from 'antd'
import Timer from 'react-compound-timer'
import { getJobInformation } from '../../../api/meeting.api'
import { endMeeting } from '../../../services/MeetingServices'
import { browserNotificationHandler } from '../../../utils'
import { LONGJOB_MINPOP } from '../../../constants'
const warningTime = { seconds: 0, minutes: 0, hours: 0 }
let screenshareStarted = false
let longJobSuggest = localStorage.getItem('longJobPopUp')
export const SuggestLongJobConversion = (props) => {
	useEffect(() => {
		;(async () => {
			/**
			 * Open modal for technician to suggest project after 25 minurtes
			 */
			longJobSuggest = localStorage.getItem('longJobPopUp')
			if (props.runningSeconds && props.runningSeconds >= LONGJOB_MINPOP && longJobSuggest === null) {
				if (props.job && props.job.id) {
					let jobInfoUpdatedResponse = await getJobInformation(props.job.id, props?.user?.id)
					if (jobInfoUpdatedResponse && jobInfoUpdatedResponse.data && jobInfoUpdatedResponse.data.is_long_job === false) {
						localStorage.setItem('longJobPopUp', props.job?.id)
						suggestLongJobConversionPopup()
					}
				}
			}
		})()
	}, [props.runningSeconds])

	const suggestLongJobConversionPopup = () => {
		const key = 'convertLongJobSuggestion'
		const btn = (
			<Button
				// variant="danger"
				className="mt-2"
				size="small"
				onClick={() => {
					notification.close('convertLongJobSuggestion')
					localStorage.setItem('longJobPopUp', 'skipit')
				}}
			>
				Skip
			</Button>
		)

		let body = 'To save time and money Please evaluate if this is a project and can be converted'
		// browserNotificationHandler(body)
		notification.info({
			key,
			duration: null,
			btn,
			message: body,
			description: '',
		})
	}

	return <></>
}